import { render, staticRenderFns } from "./HeaderMessage.vue?vue&type=template&id=255e7804&scoped=true"
import script from "./HeaderMessage.vue?vue&type=script&lang=js"
export * from "./HeaderMessage.vue?vue&type=script&lang=js"
import style0 from "./HeaderMessage.vue?vue&type=style&index=0&id=255e7804&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e7804",
  null
  
)

export default component.exports